import { useProposalPreview } from "@/modules/property-tracks/hooks/rental-financial-proposal/proposal-preview.hook";
import { MenuItem } from "@mui/material";

export default function PreviewProposal({ fileUrl }: { fileUrl: string }) {
  const { showPreview, PreviewModal } = useProposalPreview();

  return (
    <>
      <MenuItem
        sx={(t) => t.nawy.typography.english.variants.body.md.regular}
        onClick={() => showPreview(fileUrl)}
      >
        Preview
      </MenuItem>
      <PreviewModal />
    </>
  );
}
